/**
 * An enum that represents the types of emitter nozzles
 */
export enum EmitterType {
  /**
   * Constant for the circular emitter type
   */
  Circle = 'circle',
  /**
   * Constant for the rectangular emitter type
   */
  Rectangle = 'rectangle'
}
